<div class="font-body-1" [formGroup]="parentForm" [class.ms-large-b]="displayContainerStyles">
  <div [formArrayName]="controlName">
    @for (group of formArray.controls; track group; let i = $index) {
      @if (i === 0 || !hideGroups) {
        <div
          [class]="'form-array-item-' + controlName"
          [class.ms-xlarge-t]="i > 0 && !isNestedArray && !compressedList"
          [class.ms-xsmall-t]="i > 0 && isNestedArray"
          [formGroupName]="i"
          [ngClass]="{
            'pr-small-x pr-small-t grey-25-bg nested-array-item': isNestedArray,
          }"
        >
          @if (displayLabels) {
            <div class="bold-type nordic-blue-900-text ms-xxsmall-b item-label font-body-1">
              {{ translationPrefix + '.label' | finLocalization }} {{ i + 1 }}
            </div>
          }
          <ng-container *ngTemplateOutlet="formGroup; context: { parentFormGroup: group, index: i }" />
          @if (i >= minGroups) {
            <fcom-button
              (clickBtn)="removeFormGroup(i)"
              class="ms-small-t remove-button"
              [class.disabled-area]="disabled"
              [class.ms-xsmall-b]="!compressedList"
              [ngClass]="'form-array-remove-' + controlName"
              [attr.data-testid]="'remove-' + controlName"
              [disabled]="disabled"
              [icon]="{ name: SvgLibraryIcon.TRASH, position: IconPosition.LEFT }"
              [text]="
                (translationPrefix + '.remove' | finLocalization) + (displayLabels ? ' ' + (i + 1).toString() : '')
              "
              [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
            />
          }
        </div>
      }
    }
  </div>
  @if (!hideGroups) {
    <div
      [ngClass]="{ 'pr-small-x grey-25-bg nested-array-item': isNestedArray }"
      [class.ms-xsmall-t]="formArray.length > 0"
    >
      <fcom-button
        #addGroupButtonElement
        (clickBtn)="addFormGroup()"
        [aria]="{ describedby: 'addPassengerDescription' }"
        class="add-button"
        [ngClass]="'form-array-add-' + controlName"
        [class.ms-xsmall-y]="!compressedList"
        [class.disabled-area]="disabled"
        [attr.data-testid]="'add-' + controlName"
        [disabled]="formArray.length >= maxGroups || disabled"
        [focusOnRender]="focusToButton$ | async"
        [icon]="{ name: SvgLibraryIcon.PLUS, position: IconPosition.LEFT }"
        [text]="translationPrefix + '.add' | finLocalization"
        [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
      />
      <span id="addPassengerDescription" class="is-vishidden">{{ 'formArray.addNewItem' | finLocalization }}</span>
    </div>
  }
</div>
